import { AppointmentTypeEnum } from '@eigtech/restoration-types'
import { exhaustive } from 'exhaustive'
import { startCase } from 'lodash-es'

const appointmentTypeLabelRecord: Partial<Record<AppointmentTypeEnum, string>> = {}

export const getAppointmentTypeLabel = (status: AppointmentTypeEnum) =>
  appointmentTypeLabelRecord[status] ?? startCase(status)

export const getAppointmentTypeColorScheme = (appointmentType: AppointmentTypeEnum) =>
  exhaustive(appointmentType, {
    inspection: () => 'teal',
    mitigation: () => 'cyan',
    restoration: () => 'purple',
    review: () => 'blue',
  })
